module.exports = __webpack_public_path__ + "static/media/industries-fodder-s.0e720ca2.jpg";